import React from 'react';
import Lottie from "lottie-react";
import notFoundLottie from  "../../assets/lottie/not-found.json" ;
import "./notfound.css"

const NotFound = () => {
  return (
    <div className='not-found-container'>
            <Lottie  loop={false} animationData={notFoundLottie} className="not-found-lottie"    />
            <h3>404 Not Found</h3>
            <h5>Ooops... Unable to find the restaurent</h5>
    </div>
  )
}

export default NotFound